import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'synfrastructure';
import { SubmissionError } from 'redux-form';
import querystring from 'querystring';
import { selectActiveGolfSchool, selectClasses } from './selectors';
import { getGolfSchools, createClass, editSchool } from './actions';
import { formatValidationErrors } from '../common/utils/getApiReducer';

import AddClassForm from './AddClassForm';
import EditSchoolForm from "./EditSchoolForm";
import Breadcrumb from '../common/components/Breadcrumb';
import ClassList from './ClassList';
import Icon from '../common/icons/Icon';

class GolfSchoolPage extends Component {
  constructor(props) {
    super(props);

    const { search } = props.location;
    const qs = search ? querystring.parse(search.slice(1)) : {};

    this.state = {
      addClassModalVisible: false,
      editSchoolModalVisible: false,
      page: qs.page || 1,
    };
  }

  setPage = (page) => {
    const qs = this.props.location.search
      ? querystring.parse(this.props.location.search.slice(1))
      : {};

    qs.page = page;

    this.props.history.push(
      `${this.props.match.url}?${querystring.stringify(qs)}`
    );
  };

  toggleAddClassModal = () => {
    this.setState((state) => ({
      addClassModalVisible: !state.addClassModalVisible,
    }));
  };

  toggleEditSchoolModal = () => {
    this.setState((state) => ({
      editSchoolModalVisible: !state.editSchoolModalVisible,
    }));
  };

  onAddClassSubmit = (values) => {
    const { activeGolfSchool, dispatch } = this.props;

    return dispatch(createClass(activeGolfSchool.id, values)).then((action) => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.props.history.push(
          `/golf-schools/${activeGolfSchool.id}/classes/${action.json.id}`
        );
      }
    });
  };

  onEditSchoolSubmit = (values) => {
    const { activeGolfSchool, dispatch } = this.props;

    return dispatch(editSchool(activeGolfSchool.id, values)).then((action) => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        return dispatch(getGolfSchools()).then(() => {
          this.toggleEditSchoolModal();
        });
      }
    });
  }

  render() {
    const { activeGolfSchool, classes, location, initialValues } = this.props;
    const { addClassModalVisible, editSchoolModalVisible, page } = this.state;

    if (!activeGolfSchool || !classes) {
      return null;
    }

    const breadcrumbs = [
      {
        label: 'Golf Schools',
        to: '/golf-schools',
      },
      {
        label: activeGolfSchool.name,
        to: null,
      },
    ];

    return (
      <div className="admin-paper">
        <Modal
          isVisible={addClassModalVisible}
          onClose={this.toggleAddClassModal}
        >
          <AddClassForm
            onSubmit={this.onAddClassSubmit}
            onCancel={this.toggleAddClassModal}
          />
        </Modal>
        <Modal
          isVisible={editSchoolModalVisible}
          onClose={this.toggleEditSchoolModal}
        >
          <EditSchoolForm
            school={activeGolfSchool}
            initialValues={initialValues}
            onSubmit={this.onEditSchoolSubmit}
            onCancel={this.toggleEditSchoolModal}
          />
        </Modal>
        <div className="admin-paper__header">
          <Breadcrumb crumbs={breadcrumbs} />
          <div className="admin__edit-school-button">
            <button
              onClick={this.toggleEditSchoolModal}
              className="button button--theme--outline button--icon"
            >
              <Icon icon="Pencil" />
              Edit School
            </button>
          </div>
          <button
            onClick={this.toggleAddClassModal}
            className="admin__add-button"
          >
            <Icon icon="Plus" /> Add Class
          </button>
        </div>
        <ClassList
          school={activeGolfSchool}
          classes={classes.data}
          setPage={this.setPage}
          page={page}
          search={location.search}
        />
      </div>
    );
  }
}

export default connect((state, ownProps) => {
  const activeGolfSchool = selectActiveGolfSchool(state, ownProps.match.params.schoolId)
  return {
    activeGolfSchool,
    classes: selectClasses(state),
    initialValues: activeGolfSchool
      ? {
          days: activeGolfSchool.days,
          price: activeGolfSchool.price,
          location: activeGolfSchool.location,
        }
      : null,
  };
})(GolfSchoolPage);



// WEBPACK FOOTER //
// ./src/golf-schools/GolfSchoolPage.js